import 'can-construct-super';
import MenuBase from "@/js/controllers/menu/base.js";


const MenuHyper = MenuBase.extend(
    {
        defaults: {}
    },
    {
        init() {

            let timeout = 0;
            const hrefCollection = this.element.querySelectorAll('a');
            const panelCollection = document.querySelectorAll('.site-hyper--panel');

            panelCollection.forEach(function (element, i) {
                element.addEventListener('mouseleave', () => {
                    element.classList.remove('show')
                });
            })


            hrefCollection.forEach(function (element, i) {
                element.addEventListener('mouseenter', () => {
                    timeout = setTimeout(function () {

                        panelCollection.forEach(function (element, i) {
                            element.classList.remove('show')
                        })

                        const panelElement = panelCollection[i];
                        if(panelElement.classList.contains('show')) {
                            panelElement.classList.remove('show')
                        } else {
                            panelElement.classList.add('show')
                        }

                        /*         $(".mm-panel-wrap").fadeOut(0);
                                 $(".mm-panel-wrap").fadeIn(100);

                                 let thisHref = $(this).attr("data-top");

                                 if (!$(this).hasClass('active')) {
                                     $("a[data-top]").removeClass('active');
                                     $(this).addClass("active");

                                     $('.j-mm-panel[data-id]').removeClass('show');
                                     $('.j-mm-panel[data-id=' + thisHref + ']').addClass('show');
                                 }*/


                    }.bind(this), 200);
                })

                element.addEventListener('mouseleave', () => { clearTimeout(timeout); });
            })


/*
            $(".j-mm-panel").on('mouseleave', function () {
                $("a[data-top]").removeClass('active');
                $(".j-mm-panel").removeClass('show');
            })

            $(".site-header").on('mouseenter', function () {
                $("a[data-top]").removeClass('active');
                $(".j-mm-panel").removeClass('show');
            })*/


        },

    });

export default MenuHyper;
